module.exports = __webpack_public_path__ + "static/media/wildkard.113f8f4f.png";